import React from 'react'
import Expenses from 'src/app/Expenses/Expenses'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AllExpenseReports from 'src/navigation/appRoutes/expenses/expensesAllReports.appRoute'
import ExpensesExpenseReports from 'src/navigation/appRoutes/expenses/expensesExpenseReports.appRoute'
import ExpensesNeedsApprovalAppRoute from 'src/navigation/appRoutes/expenses/expensesNeedsApproval.appRoute'
import OrgExpenseReport from 'src/navigation/appRoutes/expenses/expensesOrgExpenseReport.appRoute'
import OrgExpenseReportsHistoricalReports from 'src/navigation/appRoutes/expenses/expensesOrgExpenseReportsHistoricalReports.appRoute'
import ExpensesOutOfPocketReports from 'src/navigation/appRoutes/expenses/expensesOutOfPocketReports.appRoutes'
import ExpensesTransactions from 'src/navigation/appRoutes/expenses/expensesTransactions.appRoute'
import YourExpenseReports from 'src/navigation/appRoutes/expenses/expensesYourReports.appRoute'
import ReimbursementsAppRoute from 'src/navigation/appRoutes/expenses/reimbursements.appRoute'
import SubmitExpensesAppRoute from 'src/navigation/appRoutes/expenses/submitExpenses.appRoute'
import { expensesRouteProps } from 'src/navigation/routeProps'

const ExpensesAppRoute: AppRoute = {
  routeProps: expensesRouteProps,
  component: <Expenses />,
  subRoutes: [
    ExpensesOutOfPocketReports,
    SubmitExpensesAppRoute,
    ReimbursementsAppRoute,
    ExpensesTransactions,
    ExpensesNeedsApprovalAppRoute,
    ExpensesExpenseReports,
    AllExpenseReports,
    YourExpenseReports,
  ],
  exceptions: [OrgExpenseReport, OrgExpenseReportsHistoricalReports],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesAppRoute
